<template>
  <span
    class="Icon"
    :class="{
      'Icon--circle' : circle
    }"
    :style="`font-size:${size / 2}px`"
  >
    <img :src="src" />
    <slot></slot>
  </span>
</template>

<script>
  export default {
    props: {
      src: {
        type: String
      },

      size: {
        type: Number,
        default: 40
      },

      circle: {
        type: Boolean,
        default: false
      }
    }
  };
</script>

<style lang="scss">
  .Icon {
    @include ellipsis;
    width: 100%;
    color: rgba(var(--yellow), 1);

    img {
      width: 2em;
      height: 2em;
      margin-right: 8px;
    }

    &--circle {
      img {
        border-radius: 999px;
      }
    }
  }
</style>